export default "/static/explore/86f255d8923c60e93c55378a783a789bb15b2d64/_next/static/images/phone-cfce53e5193bf6ac351cc9ee7a560f31.png";